import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Scale } from 'lucide-react';

export const Terms: React.FC = () => {
  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      <Helmet>
        <title>Terms of Service - Asphalt Calculator</title>
        <meta name="description" content="Terms of service for using the Asphalt Calculator website. Read our usage terms and conditions." />
      </Helmet>

      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-xl p-8">
        <div className="flex items-center mb-8">
          <Scale className="h-8 w-8 text-blue-600 mr-3" />
          <h1 className="text-3xl font-bold text-slate-800">Terms of Service</h1>
        </div>

        <div className="prose max-w-none">
          <p className="text-slate-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">1. Acceptance of Terms</h2>
            <p className="text-slate-600 mb-4">
              By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">2. Use License</h2>
            <p className="text-slate-600 mb-4">
              Permission is granted to temporarily use this website for personal, non-commercial transitory viewing only.
            </p>
            <p className="text-slate-600 mb-4">This is the grant of a license, not a transfer of title, and under this license you may not:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose</li>
              <li>Attempt to decompile or reverse engineer any software contained on the website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">3. Disclaimer</h2>
            <p className="text-slate-600 mb-4">
              The materials on this website are provided on an 'as is' basis. We make no warranties, expressed or implied,
              and hereby disclaim and negate all other warranties including, without limitation, implied warranties or
              conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property
              or other violation of rights.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">4. Limitations</h2>
            <p className="text-slate-600 mb-4">
              In no event shall Asphalt Calculator or its suppliers be liable for any damages (including, without limitation,
              damages for loss of data or profit, or due to business interruption) arising out of the use or inability to
              use the materials on the website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">5. Contact Information</h2>
            <p className="text-slate-600">
              If you have any questions about these Terms of Service, please contact us at:
              <br />
              Email: info@asphaltcalculator.online
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};